import { Button } from "@/components";
import { UPLOAD_FILE_LIMIT } from "@/config";
import bytes from "bytes";
import classNames from "classnames";
import React, { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import "./style.scss";

interface Props {
  label?: string;
  buttonLabel?: string;
  isRequired?: boolean;
  text?: string;
  className?: string;
  maxSize?: number;
  maxFiles?: number;
  acceptFileTypes?: string[];
  value: File | null;
  onChange(params: File | null): void;
}
const baseStyle = {
  border: "none",
};

const activeStyle = {
  borderColor: "#35a56e",
};

const acceptStyle = {
  borderColor: "#35a56e",
};

const rejectStyle = {
  borderColor: "#CC4B39",
};

export const Upload: React.FC<Props> = ({
  className,
  maxSize = UPLOAD_FILE_LIMIT, // 25MB
  maxFiles = 1,
  value,
  onChange = () => {},
}: Props) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles[0].size > maxSize) {
        toast.error(`The file size limit is ${bytes(maxSize)}.`);
      } else {
        const files = acceptedFiles.filter((file: File) => file.size < maxSize);
        onChange(files[0]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value],
  );

  const {
    getRootProps,
    getInputProps,
    open,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    noClick: true,
    multiple: false,
    maxFiles,
    // maxSize,
    accept: {
      "application/zip": [".zip"],
      "application/x-tar": [".tar"],
      "application/gzip": [".tar.gz"],
    },
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept],
  );

  const removeFile = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(null);
  };
  return (
    <div className={classNames("upload-control", className)}>
      <div {...getRootProps({ className: "dropzone", style })}>
        <div className="d-flex flex-wrap">
          {value && (
            <div className="upload-control__file">
              <div className="upload-control__file__name">{value?.name}</div>
              <div
                className="upload-control__file__remove"
                onClick={removeFile}
              >
                Remove
              </div>
            </div>
          )}
        </div>
        <input {...getInputProps()} />
        {!value && (
          <Button icon="folder" onClick={open}>
            Browse
          </Button>
        )}
      </div>
    </div>
  );
};
